export const localStorageController = {
  set: (key: string, value: string) => window.localStorage.setItem(key, value),
  get: (key: string) => window.localStorage.getItem(key) || null,
  remove: (key: string) => window.localStorage.removeItem(key),
};
